import { CompassDigitalId } from '@compassdigital/id';
export default () => {
  // Map CompassDigitalId utils
  const { valid } = CompassDigitalId;

  return { valid };
};
